import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';
export const createAttributeValueFunc = createAsyncThunk(
  "create attribute value function",
  async ({ attributeId, data },thunkAPI) => {
    try {
      const response = await api.post(`/dashboard/attributes/${attributeId}/values`,data);
      return response.data.data.value;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

const createAttributeValueSlicer = createSlice({
  name: "create attribute value slicer",
  initialState: {
          loading: false,
          data: null,
          error: null,
          apiErrors: {},
          successMessage: "",
      },
      reducer: {},
      extraReducers: (builder) => {
          builder.addCase(createAttributeValueFunc.pending, (state) => {
              state.loading = true;
              state.error = null;
              state.data = null;
              state.apiErrors = {};
          })
              .addCase(createAttributeValueFunc.fulfilled, (state, action) => {
                  state.loading = false;
                  state.data = action.payload;
                  state.successMessage = action.payload?.message || "";
  
              })
              .addCase(createAttributeValueFunc.rejected, (state, action) => {
                  state.loading = false;
                  state.data = null;
                  state.error = true;
                  state.apiErrors = action.payload?.errors || {};
              });
      },
});

export default createAttributeValueSlicer.reducer;
